import { getAuth } from "firebase/auth";
export * from "firebase/auth";

export const setLanguageCode = (_: never, lang: string) => {
    getAuth().languageCode = lang;
};
